// extracted by mini-css-extract-plugin
export default {"registerContainer":"Login_registerContainer__gHTxe"};